import styled from "styled-components";

export const Page = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.background};
  overflow-x: hidden;
`;

const BREAKPOINT_MOBILE = "768px";
const BREAKPOINT_MEDIUM = "1100px";

export const HeaderSticky = styled.div`
  position: sticky;
  top: 0;
  z-index: 50;
  background: ${({ theme }) => theme.colors.background};
`;

export const HeaderInner = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  padding: 7px 24px;

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    padding: 7px 16px 7px 56px;
  }
`;

export const TabNavSticky = styled.div<{ $sidebarCollapsed?: boolean }>`
  position: sticky;
  top: 73px;
  z-index: 40;
  background: ${({ theme }) => theme.colors.background};
  padding: 0 12px 32px;
  width: 100%;
  max-width: ${({ $sidebarCollapsed }) => ($sidebarCollapsed ? "min(2400px, calc(100vw - 144px))" : "min(2400px, calc(100vw - 320px))")};
  margin: 0 auto;
  box-sizing: border-box;

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    top: 55px;
    padding: 0 16px 28px;
    max-width: 100%;
  }
`;

export const TabNavInner = styled.div`
  padding: 0;
  display: flex;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
`;

export const TabNav = styled.nav`
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: stretch;
  background: ${(props: any) => props.theme.colors.interfacePure0};
  justify-content: center;
  width: 100%;
  border-radius: 6px;
  box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.1);
  padding: 0;
`;

export const TabButton = styled.button<{ $active: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  gap: 8px;
  padding: 18px 20px;
  font-size: 14px;
  color: ${({ theme, $active }) => ($active ? theme.colors.primaryRed400 : theme.colors.interfaceText400)};
  border-bottom: 2px solid ${({ theme, $active }) => ($active ? theme.colors.primaryRed400 : "transparent")};
  background: transparent;
  border-top: none;
  border-left: none;
  border-right: none;
  font-weight: ${({ $active }) => ($active ? 600 : 500)};
  user-select: none;
  white-space: nowrap;

  &:hover {
    opacity: 0.8;
  }
`;

export const ContentCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    gap: 20px;
  }
`;

export const HistoricoPlaceholder = styled.div`
  padding: 48px;
  text-align: center;
  color: ${({ theme }) => theme.colors.interfaceGray400};
`;

export const HeaderLeft = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0;

  .voltar-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 5px;
    cursor: pointer;
    background: transparent;
    border: none;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.interfaceGray400};

    svg {
      flex-shrink: 0;
      min-width: 20px;
      min-height: 20px;
    }

    @media (max-width: 800px) {
      display: none;
    }
  }

  .divider {
    width: 1px;
    height: 16px;
    margin: 0 20px;
    border-left: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};

    @media (max-width: 800px) {
      display: none;
    }
  }

  h1 {
    font-size: 32px;
    font-weight: 400;
    margin: 0;
    color: ${({ theme }) => theme.colors.interfaceText400 || theme.colors.interfaceTextPrimary};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;

    @media (max-width: ${BREAKPOINT_MOBILE}) {
      font-size: 1.5rem;
    }
  }
`;

export const Content = styled.div<{ $sidebarCollapsed?: boolean }>`
  padding: 24px 12px;
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  overflow: visible;

  @media (min-width: 769px) {
    max-width: ${({ $sidebarCollapsed }) => ($sidebarCollapsed ? "min(2400px, calc(100vw - 144px))" : "min(2400px, calc(100vw - 320px))")};
  }
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    padding: 16px;
    min-width: 0;
  }
`;

/* Card: Precificação de serviços */
export const PricingCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: ${BREAKPOINT_MEDIUM}) {
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 10px;
    gap: 8px;

    /* Título em uma linha, botão Editar preços ocupa toda a linha abaixo */
    > *:first-child {
      width: 100%;
    }

    > *:last-child {
      display: flex;
      width: 100%;
      justify-content: center;
    }
  }
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    margin-bottom: 20px;
    gap: 16px;
  }
`;

export const PricingCardHeaderLeft = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 0 1 auto;

  @media (max-width: ${BREAKPOINT_MEDIUM}) {
    flex-wrap: wrap;
    flex: 1 1 auto;
  }
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    flex-wrap: nowrap;
    overflow: hidden;
  }
`;

export const PricingTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.interfaceTextPrimary};
  white-space: nowrap;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (max-width: ${BREAKPOINT_MEDIUM}) {
    white-space: normal;
    word-break: break-word;
    flex: 1;
    min-width: 0;
  }
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    font-size: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const Card = styled.section`
  padding: 24px;
  background: ${(props: any) => props.theme.colors.white};
  border: none;
  border-radius: 6px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  overflow: visible;
  isolation: isolate;

  @media (max-width: ${BREAKPOINT_MEDIUM}) {
    padding: 14px 16px 16px;
  }
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    padding: 16px;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: ${BREAKPOINT_MEDIUM}) {
    flex-direction: column;
    align-items: stretch;
    margin-bottom: 12px;
    gap: 8px;

    > *:last-child {
      display: flex;
      width: 100%;
      justify-content: center;
    }
  }
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    margin-bottom: 20px;
    gap: 16px;
  }
`;

export const CardHeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1 1 auto;

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    flex-wrap: wrap;
  }
`;

export const PricingIconWrap = styled.span`
  display: inline-flex;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  &.pricing-icon-lg svg {
    width: 50px;
    height: 50px;
    flex-shrink: 0;
  }
`;

export const PricingTitleWrap = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  flex: 0 1 auto;
  flex-wrap: nowrap;

  @media (max-width: ${BREAKPOINT_MEDIUM}) {
    flex-wrap: wrap;
    flex: 1 1 auto;
  }
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    flex-wrap: nowrap;
    min-width: 0;
    overflow: hidden;
  }
`;

export const CardTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.interfaceTextPrimary};
  white-space: nowrap;
  min-width: 0;

  @media (max-width: ${BREAKPOINT_MEDIUM}) {
    white-space: normal;
    word-break: break-word;
    flex: 1;
    min-width: 0;
  }
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    font-size: 15px;
    white-space: normal;
    word-break: break-word;
  }
`;

export const HelpIconWrap = styled.span`
  display: inline-flex;
  cursor: help;
  flex-shrink: 0;
  align-items: center;
  width: fit-content;
  min-width: 24px;

  > div {
    display: inline-flex !important;
    width: auto !important;
    min-width: 0 !important;
    overflow: visible !important;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  flex-wrap: nowrap;
  white-space: nowrap;

  .save-btn-labels .btn-label-mobile {
    display: none;
  }
  .save-btn-labels .btn-label-full {
    display: inline;
  }
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    .save-btn-labels .btn-label-mobile {
      display: inline;
    }
    .save-btn-labels .btn-label-full {
      display: none;
    }
  }

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    flex-flow: row nowrap;
    gap: 8px;

    > button,
    > a {
      flex: 1 1 0;
      min-width: 0;
    }
  }
`;

export const ButtonSecondary = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  height: 40px;
  padding: 0 1rem;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
  background: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.interfaceTextPrimary};
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const ButtonPrimary = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  height: 40px;
  padding: 0 1.25rem;
  border-radius: 6px;
  border: 2px solid ${({ theme }) => theme.colors.primaryRed400};
  background: ${({ theme }) => theme.colors.primaryRed400};
  color: ${(props: any) => props.theme.colors.pureWhite};
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

  .btn-label-mobile {
    display: none;
  }
  .btn-label-full {
    display: inline;
  }
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    .btn-label-mobile {
      display: inline;
    }
    .btn-label-full {
      display: none;
    }
  }
`;

export const TableWrap = styled.div`
  overflow-x: auto;
  border: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
  border-radius: 6px;
  overflow: hidden;

  @media (max-width: ${BREAKPOINT_MEDIUM}) {
    overflow: visible;
    border: none;
    border-radius: 0;
  }
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    overflow: visible;
    border: none;
    border-radius: 0;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  @media (max-width: ${BREAKPOINT_MEDIUM}) {
    display: none;
  }
`;

export const Thead = styled.thead``;

export const Th = styled.th`
  text-align: left;
  padding: 16px 12px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.interfaceGray400};
  font-weight: 600;
  background: ${(props: any) => props.theme.colors.cf8fafc};
  border-bottom: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};

  &.center {
    text-align: center;
  }
  &.right {
    text-align: right;
  }
`;

export const Tbody = styled.tbody``;

export const Tr = styled.tr`
  border-bottom: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
  background: ${(props: any) => props.theme.colors.white};
`;

export const Td = styled.td`
  padding: 16px 12px;
  font-size: 14px;
  font-weight: 500;

  &.center {
    text-align: center;
  }
  &.right {
    text-align: right;
  }
`;

export const ModalidadeBadge = styled.span`
  background: ${({ theme }) => theme.colors.interfacePure100};
  color: ${({ theme }) => theme.colors.interfaceTextPrimary};
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
`;

export const ConsultaBadge = styled.span`
  background: ${(props: any) => props.theme.colors.cfef3c7};
  color: ${(props: any) => props.theme.colors.c92400e};
  border: 1px solid rgb(252, 211, 77);
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
`;

export const LoadingWrap = styled.div`
  padding: 24px;
`;

export const InputSmall = styled.input`
  width: 56px;
  padding: 6px 8px;
  border: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
  border-radius: 6px;
  font-size: 14px;
  text-align: center;
  &:disabled {
    background: ${(props: any) => props.theme.colors.cf1f5f9};
    cursor: not-allowed;
  }
`;

export const FieldLabel = styled.label`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.interfaceGray400};
  text-transform: uppercase;
  font-weight: 500;

  &.no-margin {
    margin-bottom: 0;
  }
`;

export const SobConsultaHeader = styled.span`
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
`;

export const HelpIconWrapMargin = styled.span`
  margin-left: 4px;
  cursor: help;
  display: inline-flex;
`;

export const TdEmpty = styled(Td)`
  text-align: center;
  color: ${({ theme }) => theme.colors.interfaceGray400};
  padding: 32px;
`;

export const TdTooltipTrigger = styled.span`
  cursor: help;
`;

export const TdCellWithError = styled.div<{ $hasError?: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  ${({ theme, $hasError }) =>
    $hasError &&
    `
    input {
      border-color: ${theme.colors?.primaryRed400 || "#dc2626"} !important;
      outline-color: ${theme.colors?.primaryRed400 || "#dc2626"};
    }
  `}
`;

export const FieldError = styled.span`
  color: ${({ theme }) => theme.colors?.primaryRed400 || "#dc2626"};
  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
  text-align: center;
`;

/* Mobile card layout para listagem de serviços */
export const MobileCardList = styled.div`
  display: none;
  flex-direction: column;
  gap: 12px;

  @media (max-width: ${BREAKPOINT_MEDIUM}) {
    display: flex;
  }
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    gap: 18px;
  }
`;

export const MobileServiceCard = styled.div`
  background: ${(props: any) => props.theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    padding: 18px;
  }

  .mobile-card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 8px;
  }
  @media (max-width: ${BREAKPOINT_MOBILE}) {
    .mobile-card-header {
      margin-bottom: 12px;
    }
    .mobile-card-tag-profissional {
      margin-bottom: 12px;
    }
    .mobile-card-creditos-valor {
      margin-bottom: 12px;
    }
  }
  .mobile-card-servico {
    font-weight: 700;
    font-size: 16px;
    color: ${({ theme }) => theme.colors.interfaceTextPrimary};
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    .mobile-card-servico-trigger {
      cursor: help;
      display: block;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .mobile-card-creditos-header {
    flex-shrink: 0;
    font-size: 14px;
    font-weight: 500;
  }

  .mobile-card-profissional-value {
    color: inherit;
    font-size: 14px;
  }

  .mobile-edit-creditos-label {
    margin-bottom: 0;
  }
  .mobile-card-tag-profissional {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin-bottom: 8px;
  }
  .mobile-card-creditos-valor {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.interfaceGray400};
  }
  .mobile-card-creditos-valor span {
    white-space: nowrap;
  }
`;

export const MobileCardTotal = styled.span`
  font-weight: 700;
  color: ${({ theme }) => theme.colors.interfaceSuccess};
  flex-shrink: 0;
`;

export const MobileCardEditRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0;
  margin-top: 8px;
  padding-top: 8px;

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    margin-top: 16px;
    padding-top: 16px;
  }

  .label {
    font-size: 12px;
    color: ${({ theme }) => theme.colors.interfaceGray400};
    font-weight: 500;
  }

  .mobile-edit-creditos-row {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    padding-bottom: 12px;
    margin-bottom: 12px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.interfaceBorder100};

    @media (max-width: ${BREAKPOINT_MOBILE}) {
      padding-bottom: 16px;
      margin-bottom: 16px;
    }
  }

  .mobile-edit-sobconsulta-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;

export const ToggleSwitch = styled.button<{ $on: boolean }>`
  position: relative;
  width: 44px;
  height: 24px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  background: ${({ theme, $on }) =>
    $on ? theme.colors.primaryRed400 : theme.colors.interfaceBorder100};
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
`;

export const ToggleSwitchThumb = styled.span<{ $on: boolean }>`
  position: absolute;
  top: 2px;
  left: ${({ $on }) => ($on ? 22 : 2)}px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${(props: any) => props.theme.colors.white};
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: left 0.2s ease;
`;
